import { Link, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import {
  BadgeFileStyled,
  BoxDownloadStyled,
  TypoDownloadStyled,
} from './cv-download.styled';
import { Stack } from '@material-ui/core';
import { DocumentIcon } from '@heroicons/react/24/solid';
import { IconSize } from '@constants';
import { EyeIcon } from '@heroicons/react/24/outline';

interface IProps {
  profile: string;
  link: string;
}

const CVDownload = ({ profile, link }: IProps) => {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <BoxDownloadStyled>
      <Stack direction={'row'} gap={2}>
        <BadgeFileStyled>
          <DocumentIcon
            height={IconSize.md}
            color={theme.palette.dark.dark_4}
          />
        </BadgeFileStyled>
        <TypoDownloadStyled>{`${t('CV_OF')} ${profile}`}</TypoDownloadStyled>
      </Stack>

      <Link href={link} download={true} target="_blank">
        <EyeIcon height={IconSize.md} color={theme.palette.primary.main} />
      </Link>
    </BoxDownloadStyled>
  );
};

export default CVDownload;
